export default __webpack_public_path__ + "static/media/r.fdcbbbf6.jpg";